import LocalizedStrings from "react-localization";
import { LANG_TR } from "./langs/tr";
import { LANG_EN } from "./langs/en";


const strings = new LocalizedStrings({
  en: LANG_EN,
  tr: LANG_TR,
});


export default strings;